/**
 * @description 取得非圖片類型檔案 icon class name
 *
 * @param extension 檔案副檔名，接受 .pdf 或 pdf
 * @returns icon class name
 */
export function getFileCategoryCLassNameByExtension(extension: string): string {
  const fileCategorys: { [key: string]: string } = {
    '.pdf': 'icon-pdf',
    '.doc': 'icon-doc',
    '.docx': 'icon-doc',
    '.xls': 'icon-xls',
    '.xlsx': 'icon-xls',
    '.txt': 'icon-txt',
    '.tif': 'icon-tif',
    '.tiff': 'icon-tif'
  };
  const unknow = 'icon-unknow';
  if (extension) {
    const key = Object.keys(fileCategorys).find(
      (item) => item.indexOf(extension.trim().toLocaleLowerCase()) > -1
    );
    if (key) {
      return fileCategorys[key];
    }
  }
  return unknow;
}
